export default __webpack_public_path__ + "39a1654c9eac343488df393d05730908.png";